/* eslint-disable no-nested-ternary */
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles((theme: any) => ({
  text: ({ balanceTextColor }: { balanceTextColor: string }) => ({
    color: balanceTextColor,
    fontSize: "20px",
    fontWeight: 600
  }),
}));

type Props = {
  text: string,
  balanceIcon: IconProp | null,
  balanceTextColor: string
}

export const TotalBalanceAddorment: React.FC<Props> = ({ text, balanceIcon, balanceTextColor }) => {
  const classes = useStyles({ balanceTextColor });

  return (
    <Typography className={classes.text}>
      {balanceIcon !== null && (
        <FontAwesomeIcon icon={balanceIcon} />
      )}
      {' '}
      {text}
    </Typography>
  );
};
